import React, { memo, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';
import CustomInput from '../../components/DatePicker/CustomDatePickerInput';
import ShiftRequired from './ShiftRequired';
import Utils from '../../utils/utils';

const ShiftsRequiredByDate = (props) => {
	const minDate = new Date();
	const maxDate = new Date(minDate.getFullYear() + 2, minDate.getMonth(), minDate.getDate());
	const [isOpen, setIsOpen] = useState(false);
	const { shiftsGroup, shiftGroupIndex, updateShiftGroupDate, shiftStructures } = props;

	const onDateChange = (date) => {
		updateShiftGroupDate(shiftGroupIndex, date);
	};

	const addShift = () => {
		props.addEmptyShift(shiftGroupIndex);
	};

	const getAvailableShiftStructures = (currentShift) => {
		const availableShiftStructures = [];

		shiftStructures.forEach((shiftStructure) => {
			let found = false;
			// eslint-disable-next-line no-restricted-syntax
			for (const shift of shiftsGroup.shifts) {
				// make the current shift structure available for the current shits
				// this happens when we have a shift structure selected for this shift
				if (shift === currentShift) {
					// eslint-disable-next-line no-continue
					continue;
				}
				if (shift.shiftStructureId === shiftStructure.id) {
					found = true;
					break;
				}
			}
			if (!found) {
				availableShiftStructures.push(shiftStructure);
			}
		});
		return availableShiftStructures.sort((a, b) => {
			const aFromTime = Utils.convertTimeStringToSeconds(a.from_time);
			const bFromTime = Utils.convertTimeStringToSeconds(b.from_time);
			if (aFromTime < bFromTime) {
				return -1;
			}
			if (aFromTime > bFromTime) {
				return 1;
			}

			let aToTime = Utils.convertTimeStringToSeconds(a.to_time);
			if (aFromTime > aToTime) {
				aToTime += 24 * 3600;
			}

			let bToTime = Utils.convertTimeStringToSeconds(b.to_time);
			if (bFromTime > bToTime) {
				bToTime += 24 * 3600;
			}

			if (aToTime < bToTime) {
				return -1;
			}

			if (aToTime > bToTime) {
				return 1;
			}

			return 0;
		});
	};

	return (
		<div className={classNames('date-row', { 'shift-row-grey-background': props.isOddIndex })}>
			<div className={classNames('date-section', { 'showing-unit': props.showUnits && !props.isFlex })}>
				{props.isFirstGroup && (
					<div className="step-one">
						<p className="step-title">1. Select Date(s)</p>
					</div>
				)}
				<p className="text-head">Date</p>
				<div className={classNames('by-date-picker-wrapper', { 'is-open': isOpen })}>
					<DatePicker
						selected={new Date(shiftsGroup.date)}
						minDate={minDate}
						maxDate={maxDate}
						onChange={onDateChange}
						autoFocus={isOpen}
						open={isOpen}
						onClickOutside={() => setIsOpen(false)}
						onInputClick={() => setIsOpen(!isOpen)}
						customInput={<CustomInput />}
					/>

					{props.showAddButton && (
						<button type="button" className="add-date-button" onClick={props.addAnotherDate}>
							+ ADD ANOTHER DATE
						</button>
					)}
				</div>
			</div>

			<div className={classNames('shifts-section', { last: props.showAddButton })}>
				{props.isFirstGroup && (
					<div className="step-two">
						<p className="step-title">2. Add Shift Details</p>
					</div>
				)}
				{shiftsGroup &&
					shiftsGroup.shifts.map((shift, index) => (
						<ShiftRequired
							/* eslint-disable-next-line react/no-array-index-key */
							key={`shift${index}`}
							availableShiftStructures={getAvailableShiftStructures(shift)}
							allowRemove={props.allowRemove}
							addEmptyShift={addShift}
							shiftGroupIndex={shiftGroupIndex}
							updateShift={props.updateShift}
							shiftIndex={index}
							showOnlyFirstRowLabels={props.showOnlyFirstRowLabels && !props.isMobile}
							errors={props.errors[shift.id] || {}}
							removeShift={props.removeShift}
							shift={shift}
							date={shiftsGroup.date}
							isFlex={props.isFlex}
							isHybrid={props.isHybrid}
							isGlobalCalendar={props.isGlobalCalendar}
							currentFacility={props.currentFacility}
							showUnits={props.showUnits}
							units={props.units}
							facilityPortalUnitsEnabled={props.facilityPortalUnitsEnabled}
							showDivider={props.isMobile && index !== shiftsGroup.shifts.length - 1}
						/>
					))}
				{shiftStructures.length !== shiftsGroup.shifts.length && (
					<button type="button" className="add-shift-button" onClick={addShift}>
						{props.addShiftsButton || '+ ADD ANOTHER SHIFT'}
					</button>
				)}
			</div>
		</div>
	);
};
export default memo(ShiftsRequiredByDate);
